/* GLINT 12/09 — LE MENU : cinq choses, rien d'autre.
   1. Les images des panneaux (lames, best sellers, illustration du Studio)
      portent un data-src : elles ne se chargent qu'au premier signe
      d'intérêt (souris ou doigt sur l'en-tête, tiroir ouvert). Horizon, lui,
      précharge toutes les images de ses sous-menus au chargement de la page.
   2. Les lames des capsules (bureau) : survol = ouverture, le clavier ouvre
      au focus ; la lumière suit la souris sur la rangée et reste où la main
      la laisse.
   3. Les bandes des capsules (tiroir mobile) : LE DÉFILEMENT OUVRE LES
      LAMES, même mécanique que la section Capsules de l'accueil — la piste
      est haute, la scène colle en haut du tiroir, chaque lame garde la
      hauteur d'une lame ouverte et se déplace par translation, la suivante
      la recouvre ; un toucher sur une bande fermée y va, un second entre ;
      un balayage horizontal passe à la suivante ; le cran (vibration iOS par
      un interrupteur natif, tressaillement du contenu) marque chaque lame.
   4. Horizon re-rend l'en-tête après le chargement (section-hydration +
      morph) : les nœuds du menu sont remplacés. On rebranche ce qui apparaît.
   5. Le reflet vivant (glint-sheen.js) s'accroche aux cibles à leur
      insertion ; après le re-rendu, les cibles neuves lui échappent.
      Re-insérer un nœud non accroché le lui présente à nouveau, une fois. */
(function () {
  'use strict';
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var charge = false;
  var reprisesImages = new WeakMap();
  var attentesImages = new Map();

  function chargerElements(els) {
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-srcset')) { el.setAttribute('srcset', el.getAttribute('data-srcset')); el.removeAttribute('data-srcset'); }
      if (el.getAttribute('data-src')) { el.setAttribute('src', el.getAttribute('data-src')); el.removeAttribute('data-src'); }
    }
  }
  function charger(root) {
    if (!root) return;
    chargerElements(root.querySelectorAll('[data-src], [data-srcset]'));
    reprendreImages(root);
  }
  function enteteMenu() { return document.getElementById('header-component') || document.querySelector('#header-group .header-section'); }
  /* Les data-src du Studio appartiennent au Studio. Aucun chargement du menu
     ne doit sortir de l'en-tete. La portee suit le menu affiche, pas le type
     du pointeur : un changement de taille ou de souris ne doit pas la figer. */
  function portee() {
    var entete = enteteMenu();
    if (!entete) return null;
    var drawer = entete.getAttribute('data-menu-style') === 'drawer' || window.matchMedia('(max-width: 749px)').matches;
    return drawer ? entete.querySelector('.menu-drawer') : entete.querySelector('header-menu');
  }
  function chargerUneFois(cible) {
    var root = cible && typeof cible.querySelectorAll === 'function' ? cible : portee();
    if (!root) return;
    charge = true;
    // Les attributs sont retires apres chargement : les appels repetes sont
    // sans effet sur les images saines, mais reprennent les nouveaux noeuds.
    charger(root);
    if (finePointer) reveillerReflet(root);
  }
  function titreSecours(img) {
    if (!img || !img.classList || !img.classList.contains('glint-caps__titre')) return;
    var lame = img.closest('[data-glint-caps-lame]');
    var contenu = img.parentElement;
    var nom = lame && lame.querySelector('.glint-caps__nom-ferme');
    if (!contenu || !nom) return;
    var secours = contenu.querySelector('[data-glint-title-fallback]');
    if (img.naturalWidth > 0) {
      if (secours) secours.remove();
      img.style.removeProperty('display');
    } else if (img.complete && img.getAttribute('src')) {
      if (!secours) {
        secours = document.createElement('span');
        secours.className = 'glint-caps__nom';
        secours.setAttribute('data-glint-title-fallback', '');
        secours.textContent = nom.textContent;
        contenu.insertBefore(secours, img);
      }
      img.style.display = 'none';
    }
  }
  function imageCapsule(img) {
    return img && img.matches && img.matches('img.glint-caps__img, img.glint-caps__titre');
  }
  function imageVisible(img) {
    var root = portee();
    if (!img.isConnected || document.hidden || !root || !root.contains(img)) return false;
    if (img.closest('.menu-drawer')) {
      var details = img.closest('details');
      if (!details) return false;
      while (details) {
        if (!details.open) return false;
        details = details.parentElement && details.parentElement.closest('details');
      }
      return true;
    }
    var item = img.closest('.menu-list__list-item');
    var entree = item && item.querySelector('.menu-list__link');
    return !!entree && entree.getAttribute('aria-expanded') === 'true';
  }
  function imageSecours(img) {
    if (!imageCapsule(img)) return;
    titreSecours(img);
    if (img.classList.contains('glint-caps__img')) {
      if (img.naturalWidth > 0) img.style.removeProperty('visibility');
      else if (img.complete && img.getAttribute('src')) img.style.visibility = 'hidden';
    }
  }
  function annulerReprisesCachees(toutes) {
    attentesImages.forEach(function (minuterie, img) {
      if (!toutes && imageVisible(img)) return;
      window.clearTimeout(minuterie);
      attentesImages.delete(img);
    });
  }
  /* Une erreur reseau ne doit pas laisser une collection sans nom. Deux
     reprises au maximum par image, seulement tant que son panneau est ouvert.
     On conserve le fichier et sa version ; aucune image saine n'est retouchee. */
  function reprendreImage(img) {
    if (!imageCapsule(img) || !img.complete || img.naturalWidth > 0 || !imageVisible(img) || attentesImages.has(img)) return;
    var source = img.currentSrc || img.getAttribute('src');
    if (!source) return;
    var url;
    try { url = new URL(source, window.location.href); } catch (e) { return; }
    if (!(url.origin === window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0) && url.hostname !== 'cdn.shopify.com') return;
    function identite(cible) {
      var copie = new URL(cible.href);
      copie.searchParams.delete('width');
      copie.searchParams.delete('_glint_retry');
      return copie.href;
    }
    var asset = identite(url);
    var etat = reprisesImages.get(img);
    if (!etat || etat.asset !== asset) {
      etat = { asset: asset, essais: 0, echecs: new Set(), candidats: [] };
      (img.getAttribute('srcset') || '').split(',').forEach(function (entree) {
        var largeur = entree.trim().match(/^(.*)\s+(\d+)w$/);
        if (!largeur || Number(largeur[2]) > 1200) return;
        try {
          var candidat = new URL(largeur[1], window.location.href);
          if (identite(candidat) === asset) etat.candidats.push({ url: candidat.href, width: Number(largeur[2]) });
        } catch (e) {}
      });
      reprisesImages.set(img, etat);
    }
    if (etat.essais >= 2) return;
    etat.echecs.add(url.href);
    var disponibles = etat.candidats.filter(function (candidat) { return !etat.echecs.has(candidat.url); });
    var largeurEchec = Number(url.searchParams.get('width')) || 0;
    var prochain = disponibles.filter(function (candidat) { return candidat.width > largeurEchec; }).sort(function (a, b) { return a.width - b.width; })[0]
      || disponibles.sort(function (a, b) { return b.width - a.width; })[0];
    var reprise = prochain ? new URL(prochain.url) : new URL(url.href);
    // Les assets de theme et les titres n'ont pas toujours de srcset.
    if (!prochain) reprise.searchParams.set('_glint_retry', String(etat.essais + 1));
    var minuterie = window.setTimeout(function () {
      attentesImages.delete(img);
      if (!imageVisible(img) || (img.currentSrc || img.getAttribute('src')) !== source || img.naturalWidth > 0) return;
      etat.essais++;
      // Une seule candidate pour que le navigateur ne rechoisisse pas l'URL en echec.
      if (img.hasAttribute('srcset')) img.setAttribute('srcset', reprise.href);
      img.setAttribute('src', reprise.href);
    }, etat.essais === 0 ? 250 : 750);
    attentesImages.set(img, minuterie);
  }
  function reprendreImages(root) {
    if (!root) return;
    root.querySelectorAll('img.glint-caps__img[src], img.glint-caps__titre[src]').forEach(function (img) {
      if (!img.complete) return;
      imageSecours(img);
      reprendreImage(img);
    });
  }
  /* Au repos après le chargement, la première image du Studio (mur beige,
     premier plan, trois pièces) est préchauffée : la carte est prête à la
     première ouverture du tiroir, sans rien toucher pendant un geste. */
  function prechauffer() {
    if (charge) return;
    var root = portee();
    var carte = root && root.querySelector('.glint-menu__carte-studio');
    if (!carte) return;
    chargerElements(carte.querySelectorAll('.glint-anim__fond--1, .glint-anim__lum--1, .glint-anim__cadre img'));
  }

  function reveillerReflet(root) {
    if (!root) return;
    var cibles = root.querySelectorAll('[data-glint-sheen-target]:not([data-glint-sheen]):not([data-glint-sheen-reveil])');
    for (var i = 0; i < cibles.length; i++) {
      var el = cibles[i];
      var parent = el.parentNode;
      if (!parent) continue;
      el.setAttribute('data-glint-sheen-reveil', '1');
      var suivant = el.nextSibling;
      parent.removeChild(el);
      parent.insertBefore(el, suivant);
    }
  }

  /* ---- 2. Les lames du bureau ------------------------------------------ */
  function brancherLames(rangee) {
    if (rangee.getAttribute('data-glint-caps-ok')) return;
    rangee.setAttribute('data-glint-caps-ok', '1');
    var lames = Array.prototype.slice.call(rangee.querySelectorAll('[data-glint-caps-lame]'));
    function ouvrir(lame) { lames.forEach(function (l) { l.classList.toggle('is-open', l === lame); }); }
    lames.forEach(function (lame) {
      lame.addEventListener('mouseenter', function () { if (finePointer) ouvrir(lame); });
      lame.addEventListener('focus', function () { ouvrir(lame); });
      lame.addEventListener('click', function (e) {
        if (finePointer) return;
        if (!lame.classList.contains('is-open')) { e.preventDefault(); ouvrir(lame); }
      });
    });
    if (finePointer && !reduced) {
      var raf = 0, tx = 0;
      rangee.addEventListener('pointermove', function (e) {
        var r = rangee.getBoundingClientRect();
        if (!r.width) return;
        tx = ((e.clientX - r.left) / r.width - 0.5) * 140;
        if (raf) return;
        raf = window.requestAnimationFrame(function () { raf = 0; rangee.style.setProperty('--cap-tx', tx.toFixed(1) + '%'); });
      });
    }
  }

  /* ---- 3. Les bandes du tiroir : le défilement ouvre les lames ---------- */
  function brancherBandes(piste) {
    if (piste.getAttribute('data-glint-caps-ok')) return;
    var scene = piste.querySelector('[data-glint-caps-scene]');
    var rangee = piste.querySelector('[data-glint-caps-lames]');
    var tiroir = piste.closest('.glint-menu__mobile-content') || piste.closest('.menu-drawer');
    var details = piste.closest('details');
    if (!scene || !rangee || !tiroir) return;
    piste.setAttribute('data-glint-caps-ok', '1');
    var lames = Array.prototype.slice.call(rangee.querySelectorAll('[data-glint-caps-lame]'));
    var images = lames.map(function (l) { return l.querySelector('.glint-caps__img'); });
    var n = lames.length;
    if (n < 2) return;
    var M = parseFloat(getComputedStyle(piste).getPropertyValue('--cap-m')) || 12;
    var FERMEE = 52, OUVERTE = 172, PAS = 0, balayage = 0;
    var poidsPoses = [], transfPoses = [];

    function ouvrir(lame) { lames.forEach(function (l) { l.classList.toggle('is-open', l === lame); }); }

    /* Le cran : iOS vibre quand un interrupteur natif bascule ; le contenu tressaille. */
    var interrupteur = null;
    function cliquetis(lame) {
      if (!interrupteur) {
        interrupteur = document.createElement('input');
        interrupteur.type = 'checkbox';
        interrupteur.setAttribute('switch', '');
        interrupteur.setAttribute('aria-hidden', 'true');
        interrupteur.tabIndex = -1;
        interrupteur.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none;';
        piste.appendChild(interrupteur);
      }
      try { interrupteur.click(); } catch (e) {}
      var contenu = lame.querySelector('.glint-caps__contenu');
      if (contenu) { contenu.classList.remove('is-cran'); void contenu.offsetWidth; contenu.classList.add('is-cran'); }
    }

    /* La scène fait la hauteur visible du tiroir ; fermée ~9,5 % de la scène
       (40 à 64 px), ouverte = le reste ; un pas de piste = 26 % de la scène
       (léger : sept bandes = un écran et demi, pas trois). On n'écrit que si
       la hauteur a changé : écrire les hauteurs à chaque image pendant le
       défilement remettait tout en page et cassait la fin du geste. */
    var derniereH = 0;
    function tailler() {
      var H = tiroir.clientHeight;
      if (!H || H === derniereH) return;
      derniereH = H;
      scene.style.height = H + 'px';
      var f2 = Math.max(40, Math.min(64, Math.round((H + M * (n - 1)) * 0.095)));
      var o2 = Math.max(120, H - (f2 - M) * (n - 1));
      PAS = Math.round(H * 0.26);
      piste.style.height = (H + PAS * (n - 1)) + 'px';
      piste.style.setProperty('--cap-pas', PAS + 'px');
      if (f2 !== FERMEE || o2 !== OUVERTE) {
        FERMEE = f2; OUVERTE = o2; poidsPoses = []; transfPoses = [];
        piste.style.setProperty('--lame-ouverte', OUVERTE + 'px');
      }
    }
    function debutPiste() {
      return piste.getBoundingClientRect().top - tiroir.getBoundingClientRect().top + tiroir.scrollTop;
    }
    function poserPoids(k, w) {
      var arrondi = Math.round(w * 1000) / 1000;
      if (poidsPoses[k] === arrondi) return;
      poidsPoses[k] = arrondi;
      var o = Math.max(0, Math.min(1, (arrondi - 0.55) / 0.45)); o = o * o;
      var nom = Math.max(0, Math.min(1, 1 - arrondi / 0.45));
      lames[k].style.setProperty('--lame-o', o.toFixed(3));
      lames[k].style.setProperty('--lame-n', nom.toFixed(3));
    }
    function poserTransformations(poids) {
      var y = 0;
      for (var k = 0; k < n; k++) {
        var w = poids[k];
        var h = FERMEE + (OUVERTE - FERMEE) * w;
        var cle = Math.round(y) + '|' + Math.round(h * 10);
        if (transfPoses[k] !== cle) {
          transfPoses[k] = cle;
          lames[k].style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
          if (images[k]) {
            var zoom = 1 + 0.35 * (1 - w);
            images[k].style.transform = 'translate3d(0,' + (-(OUVERTE - h) / 2).toFixed(1) + 'px,0) scale(' + zoom.toFixed(3) + ')';
          }
        }
        y += h - M;
      }
    }
    function suivre() {
      if (details && !details.open) return;
      tailler();
      var longueur = piste.offsetHeight - scene.offsetHeight;
      if (longueur <= 0) return;
      var debut = debutPiste();
      var st = tiroir.scrollTop;
      /* L'aimant ne joue qu'à l'intérieur de la piste : au-delà de la dernière
         bande (ou au-dessus de la première), le défilement redevient libre —
         sinon il retenait le tiroir et empêchait d'atteindre ALL PIECES et
         l'aide (client 12/09). */
      tiroir.classList.toggle('glint-aimante', st >= debut - PAS * 0.6 && st <= debut + longueur + PAS * 0.4);
      var prog = Math.min(1, Math.max(0, (st - debut) / longueur));
      var pos = prog * (n - 1);
      var i = Math.min(n - 2, Math.floor(pos));
      var f = Math.min(1, Math.max(0, pos - i));
      var poids = [];
      for (var k = 0; k < n; k++) { poids[k] = k === i ? 1 - f : (k === i + 1 ? f : 0); poserPoids(k, poids[k]); }
      poserTransformations(poids);
      var dominante = f < 0.5 ? i : i + 1;
      if (!lames[dominante].classList.contains('is-open')) { ouvrir(lames[dominante]); cliquetis(lames[dominante]); }
    }
    function allerA(i) {
      tailler();
      tiroir.scrollTo({ top: Math.round(debutPiste() + i * PAS) + 1, behavior: 'smooth' });
    }
    /* Pendant l'élan, iOS envoie les événements par à-coups : une boucle
       requestAnimationFrame lit la position tant qu'on défile, puis s'endort. */
    var boucle = 0, dernierY = -1, dernierEvenement = 0;
    function tick() {
      if (Date.now() - dernierEvenement > 300) { boucle = 0; return; }
      if (tiroir.scrollTop !== dernierY) { dernierY = tiroir.scrollTop; suivre(); }
      boucle = window.requestAnimationFrame(tick);
    }
    function reveiller() { dernierEvenement = Date.now(); if (!boucle) boucle = window.requestAnimationFrame(tick); }
    tiroir.addEventListener('scroll', reveiller, { passive: true });
    window.addEventListener('resize', function () { dernierY = -1; tailler(); suivre(); }, { passive: true });
    /* L'aimant : le tiroir cale sur les repères de la piste (proximité : un grand
       coup de pouce traverse plusieurs bandes, la fin de course se pose sur la
       plus proche) tant que l'accordéon est ouvert. */
    function aimanter() { tiroir.classList.toggle('glint-aimante', !details || details.open); }
    /* À l'ouverture de l'accordéon, le tiroir se cale sur le DÉBUT de la piste :
       la scène pleine hauteur, première bande ouverte, titre et bouton visibles
       (client 12/09 : « ça ouvre le milieu du slider, on devrait commencer par
       en haut » — la scène se posait sous la ligne COLLECTIONS, on n'en voyait
       que le haut de la première image). */
    if (details) details.addEventListener('toggle', function () {
      aimanter();
      if (details.open) {
        dernierY = -1; tailler(); suivre();
        window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { allerA(0); }); });
      }
    });
    aimanter(); tailler(); suivre();

    /* Un toucher = on entre (client 12/09 : « il faut cliquer deux fois pour
       qu'il s'ouvre »). Le défilement sert à voir, le toucher sert à aller ;
       seul l'écho d'un balayage horizontal est ignoré. */
    lames.forEach(function (lame) {
      lame.addEventListener('click', function (e) {
        if (Date.now() - balayage < 450) { e.preventDefault(); }
      });
    });
    var tx0 = 0, ty0 = 0, tSuivi = false;
    rangee.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tSuivi = false; return; }
      tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY; tSuivi = true;
    }, { passive: true });
    rangee.addEventListener('touchend', function (e) {
      if (!tSuivi) return;
      tSuivi = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - tx0, dy = t.clientY - ty0;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      var i = lames.findIndex(function (l) { return l.classList.contains('is-open'); });
      var j = dx < 0 ? Math.min(i + 1, n - 1) : Math.max(i - 1, 0);
      if (j !== i) { allerA(j); balayage = Date.now(); }
    }, { passive: true });
  }

  /* Le clic sur une entrée à panneau ouvre le panneau, il ne quitte pas la page
     (client 12/09 : « ça nous téléporte »). Le survol l'a déjà ouvert : le clic
     ne fait rien de plus ; au doigt (tablette), le premier toucher ouvre. Le
     lien garde son href pour les robots et sans script. */
  function brancherEntrees(root) {
    var liens = (root || document).querySelectorAll('[data-glint-toggle]:not([data-glint-toggle-ok])');
    for (var i = 0; i < liens.length; i++) {
      liens[i].setAttribute('data-glint-toggle-ok', '1');
      liens[i].addEventListener('click', function (e) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        var menu = this.closest('header-menu');
        if (!menu || typeof menu.activate !== 'function') return;
        e.preventDefault();
        chargerUneFois(menu);
        menu.activate(e);
      });
    }
  }
  function fermerPanneau(menu, cible) {
    if (!menu || typeof menu.deactivate !== 'function') return;
    var item = cible.closest('.menu-list__list-item');
    var entree = item && item.querySelector('.menu-list__link');
    if (entree) entree.focus({ preventScroll: true });
    menu.deactivate({ target: cible, relatedTarget: null, type: 'click' });
  }
  function brancherEditorial(root) {
    var r = root || document;
    r.querySelectorAll('[data-glint-menu-close]:not([data-glint-close-ok])').forEach(function (bouton) {
      bouton.setAttribute('data-glint-close-ok', '1');
      bouton.addEventListener('click', function () { fermerPanneau(bouton.closest('header-menu'), bouton); });
    });
    r.querySelectorAll('header-menu.glint-menu--editorial:not([data-glint-escape-ok])').forEach(function (menu) {
      menu.setAttribute('data-glint-escape-ok', '1');
      menu.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !e.target.closest('.menu-list__list-item')) return;
        e.preventDefault(); e.stopPropagation(); fermerPanneau(menu, e.target);
      });
    });
    r.querySelectorAll('[data-glint-selection]:not([data-glint-selection-ok])').forEach(function (selection) {
      selection.setAttribute('data-glint-selection-ok', '1');
      var piste = selection.querySelector('.glint-menu__selection-rail');
      if (!piste) return;
      selection.querySelectorAll('[data-glint-selection-step]').forEach(function (bouton) {
        bouton.addEventListener('click', function () {
          var carte = piste.querySelector('.glint-menu__carte');
          if (!carte) return;
          var espace = parseFloat(getComputedStyle(piste).columnGap) || 0;
          piste.scrollBy({ left: Number(bouton.dataset.glintSelectionStep) * (carte.getBoundingClientRect().width + espace), behavior: reduced ? 'instant' : 'smooth' });
        });
      });
    });
  }
  /* ---- Les deux compositions du menu, liées aux vrais tiroirs -----------
     Le décor reçoit ses pièces ; le bundle gagne ses cadeaux. Animation finie,
     annulable dès fermeture/changement, sans moteur 3D ni reflet fabriqué.
     Horizon garde le contrôle des panneaux et du focus. Les observers ne lisent
     que l'état natif, jamais les classes que ce contrôleur écrit sur la scène. */
  var studiosMotion = [];
  var studioReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function brancherStudioMotion(root) {
    studiosMotion = studiosMotion.filter(function (controle) {
      if (controle.scene.isConnected) return true;
      controle.dispose();
      return false;
    });
    (root || document).querySelectorAll('[data-glint-studio-motion], [data-glint-menu-bundles]').forEach(function (scene) {
      if (studiosMotion.some(function (controle) { return controle.scene === scene; })) return;
      var bundle = scene.hasAttribute('data-glint-menu-bundles');
      var panneau = bundle ? scene : scene.closest('.glint-menu__studio');
      var item = scene.closest('.menu-list__list-item');
      var entree = item && item.querySelector('.menu-list__link');
      var sousMenu = scene.closest('.glint-menu__mobile-panel');
      var details = sousMenu && sousMenu.closest('details');
      var principal = scene.closest('header-drawer');
      var detailsPrincipal = principal && principal.querySelector('#Details-menu-drawer-container');
      var resume = details && details.querySelector('summary');
      var resumePrincipal = detailsPrincipal && detailsPrincipal.querySelector('summary');
      if ((!entree && !details) || !panneau || typeof MutationObserver !== 'function') return;
      var actif = false, generation = 0, attente = 0, preparation = 0, effets = [], ecoutes = [];
      function ecouter(element, nom, callback) {
        element.addEventListener(nom, callback);
        ecoutes.push(function () { element.removeEventListener(nom, callback); });
      }
      function arreter() {
        generation++;
        window.clearTimeout(attente);
        window.clearTimeout(preparation);
        attente = 0;
        preparation = 0;
        effets.forEach(function (effet) { effet.cancel(); });
        effets = [];
        scene.classList.remove('is-entering');
      }
      function animer(element, frames, duration, delay) {
        if (!element || typeof element.animate !== 'function') return;
        var effet = element.animate(frames, { duration: duration, delay: delay || 0, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
        effets.push(effet);
        effet.onfinish = function () {
          effet.cancel();
          effets = effets.filter(function (courant) { return courant !== effet; });
        };
      }
      function composer() {
        if (bundle) {
          scene.querySelectorAll('[data-glint-bundle-piece]:not([hidden])').forEach(function (piece, index) {
            var gratuit = piece.getAttribute('data-glint-bundle-role') === 'free';
            var debut = gratuit ? 'translate3d(0,45%,0) rotate(5deg) scale(.68)' : 'translate3d(0,32%,0) rotate(-5deg) scale(.85)';
            animer(piece, [{ opacity: 0, transform: debut }, { opacity: 1, transform: 'none' }], 620, index * 60);
            if (gratuit) animer(piece.querySelector('[data-glint-bundle-free]'), [{ opacity: 0, transform: 'translateY(6px) scale(.75)' }, { opacity: 1, transform: 'none' }], 300, index * 60 + 280);
          });
          return;
        }
        animer(scene.querySelector('.glint-anim__scene'), [{ transform: 'scale(1.045)' }, { transform: 'none' }], 1700, 0);
        animer(scene.querySelector('.glint-anim__guides'), [{ opacity: 0 }, { opacity: 1, offset: .24 }, { opacity: 1, offset: .6 }, { opacity: 0 }], 1300, 90);
        scene.querySelectorAll('.glint-anim__cadre').forEach(function (piece, index) {
          animer(piece, [
            { opacity: 0, transform: 'translate3d(' + (index === 1 ? '-75%' : '30%') + ',160%,0) rotate(' + (index === 1 ? '8' : '-9') + 'deg) scale(.65)' },
            { opacity: 1, transform: 'translate3d(0,-1.5%,0) rotate(.35deg) scale(1.005)', offset: .8 },
            { opacity: 1, transform: 'none' }
          ], 940, 320 + index * 150);
        });
        scene.querySelectorAll('.glint-anim__free').forEach(function (piece, index) {
          animer(piece, [{ opacity: 0, transform: 'translateY(14px) scale(.82)' }, { opacity: 1, transform: 'none' }], 420, 1220 + index * 70);
        });
        panneau.querySelectorAll('.glint-menu__etapes li').forEach(function (etape, index) {
          animer(etape, [{ opacity: .3 }, { opacity: 1 }], 380, index * 450);
        });
      }
      function preparer() {
        attente = 0;
        var tour = generation;
        charger(scene);
        /* Une image lente ne doit pas laisser les pieces masquees. Le repli
           fixe invalide aussi les decodages qui termineraient plus tard. */
        preparation = window.setTimeout(function () {
          if (tour === generation) arreter();
        }, 800);
        var images = Array.prototype.slice.call(scene.querySelectorAll('img'));
        Promise.all(images.map(function (img) {
          if (img.complete && img.naturalWidth > 0) return true;
          if (typeof img.decode !== 'function') return false;
          return Promise.resolve().then(function () { return img.decode(); }).then(function () { return img.naturalWidth > 0; }, function () { return false; });
        })).then(function (pretes) {
          if (tour !== generation || !actif || !scene.isConnected || document.hidden || studioReduced.matches) return;
          window.clearTimeout(preparation);
          preparation = 0;
          scene.classList.remove('is-entering');
          if (pretes.every(Boolean)) composer();
        }).catch(function () {
          if (tour === generation) arreter();
        });
      }
      function synchroniser() {
        var ouvert = scene.isConnected && !document.hidden && (entree
          ? entree.getAttribute('aria-expanded') === 'true'
          : details.open && resume.getAttribute('aria-expanded') === 'true' && detailsPrincipal && detailsPrincipal.open && resumePrincipal.getAttribute('aria-expanded') === 'true');
        if (ouvert === actif) {
          if (studioReduced.matches) arreter();
          return;
        }
        actif = ouvert;
        arreter();
        if (!actif) return;
        charger(scene);
        if (!studioReduced.matches && typeof scene.animate === 'function') {
          /* Avant la premiere peinture du panneau : les pieces attendent leur
             entree, sans flash de composition finie suivi d'une disparition. */
          scene.classList.add('is-entering');
          attente = window.setTimeout(preparer, 120);
        }
      }
      var observer = new MutationObserver(synchroniser);
      if (entree) observer.observe(entree, { attributes: true, attributeFilter: ['aria-expanded'] });
      else {
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
        observer.observe(resume, { attributes: true, attributeFilter: ['aria-expanded'] });
        if (detailsPrincipal) observer.observe(detailsPrincipal, { attributes: true, attributeFilter: ['open'] });
        if (resumePrincipal) observer.observe(resumePrincipal, { attributes: true, attributeFilter: ['aria-expanded'] });
      }
      var rejouer = panneau.querySelector('[data-glint-menu-replay]');
      if (rejouer) ecouter(rejouer, 'click', function () {
        if (!actif || studioReduced.matches) return;
        arreter();
        scene.classList.add('is-entering');
        preparer();
      });
      if (bundle) {
        var offres = Array.prototype.slice.call(scene.querySelectorAll('[data-glint-bundle-offer]'));
        function choisirOffre(lien) {
          var pack = Number(lien.getAttribute('data-glint-bundle-offer'));
          var total = { 2: 4, 3: 7, 4: 11 }[pack];
          if (!total || Number(scene.getAttribute('data-bundle-pack')) === pack) return;
          var pieces = Array.prototype.slice.call(scene.querySelectorAll('[data-glint-bundle-piece]'));
          /* Deux lectures de grille par choix, aucune boucle de mesure par image. */
          var precedentes = pieces.map(function (p) { return p.hidden ? null : p.getBoundingClientRect(); });
          arreter();
          scene.setAttribute('data-bundle-pack', String(pack));
          pieces.forEach(function (p, index) {
            p.hidden = index >= total;
            p.setAttribute('data-glint-bundle-role', index < pack ? 'paid' : 'free');
            var etiquette = p.querySelector('[data-glint-bundle-free]');
            if (etiquette) etiquette.hidden = index < pack;
          });
          offres.forEach(function (offre) { offre.classList.toggle('is-active', offre === lien); });
          var cta = scene.querySelector('[data-glint-bundle-cta]');
          if (cta) cta.href = lien.href;
          [['paid', pack], ['free', total - pack], ['total', total]].forEach(function (entree) {
            var compte = scene.querySelector('[data-glint-bundle-' + entree[0] + '-count]');
            if (compte) compte.textContent = String(entree[1]);
          });
          if (studioReduced.matches || !actif) return;
          pieces.forEach(function (piece, index) {
            if (piece.hidden) return;
            var avant = precedentes[index], apres = piece.getBoundingClientRect();
            var debut = avant ? 'translate3d(' + (avant.left - apres.left) + 'px,' + (avant.top - apres.top) + 'px,0) scale(' + (avant.width / apres.width) + ')' : 'translateY(38%) scale(.7)';
            animer(piece, [{ opacity: avant ? 1 : 0, transform: debut }, { opacity: 1, transform: 'none' }], 560, avant ? 0 : (index - pack) * 35);
          });
        }
        offres.forEach(function (lien) {
          ecouter(lien, 'pointerenter', function (event) { if (event.pointerType === 'mouse') choisirOffre(lien); });
          ecouter(lien, 'focus', function () { choisirOffre(lien); });
        });
      }
      studiosMotion.push({ scene: scene, sync: synchroniser, stop: arreter, dispose: function () { actif = false; arreter(); observer.disconnect(); ecoutes.forEach(function (retirer) { retirer(); }); ecoutes = []; } });
      synchroniser();
    });
  }
  function synchroniserStudios() { studiosMotion.forEach(function (controle) { controle.sync(); }); }

  function brancher(root) {
    var r = root || document;
    brancherEntrees(r);
    brancherEditorial(r);
    brancherStudioMotion(r);
    var pistes = r.querySelectorAll('[data-glint-caps-piste]');
    for (var i = 0; i < pistes.length; i++) brancherBandes(pistes[i]);
    var rangees = r.querySelectorAll('.glint-caps--lames [data-glint-caps-lames]');
    for (var j = 0; j < rangees.length; j++) brancherLames(rangees[j]);
  }

  function init() {
    brancher(document);
    var entete = enteteMenu();
    if (entete) {
      if (finePointer) {
        entete.addEventListener('pointerenter', chargerUneFois);
        entete.addEventListener('focusin', chargerUneFois);
        window.setTimeout(function () { reveillerReflet(entete); }, 400);
      } else {
        /* AU DOIGT, AUCUNE MUTATION PENDANT LE TOUCHER (client 12/09 : « il faut
           cliquer deux fois pour qu'il s'ouvre »). Safari iOS émule un survol au
           premier toucher ; si la page change pendant ce survol (nos data-src
           posés sur pointerenter), il avale le clic et seul le second passe. On
           charge à l'ouverture du tiroir, et on préchauffe au repos. */
        window.setTimeout(prechauffer, 2500);
      }
      if (typeof MutationObserver === 'function') {
        var minuterie = 0;
        new MutationObserver(function (mutations) {
          annulerReprisesCachees(false);
          if (mutations.some(function (mutation) { return mutation.type === 'attributes' && ['aria-expanded', 'open', 'data-menu-style'].indexOf(mutation.attributeName) >= 0; })) {
            reprendreImages(entete);
          }
          if (!mutations.some(function (mutation) {
            return mutation.type === 'childList' || (['data-src', 'data-srcset', 'data-menu-style'].indexOf(mutation.attributeName) >= 0 && mutation.target.hasAttribute(mutation.attributeName));
          })) return;
          window.clearTimeout(minuterie);
          minuterie = window.setTimeout(function () {
            brancher(entete);
            if (charge) charger(portee());
            if (finePointer) reveillerReflet(entete);
          }, 150);
        }).observe(entete, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-src', 'data-srcset', 'data-menu-style', 'aria-expanded', 'open'] });
      }
      entete.addEventListener('error', function (event) { imageSecours(event.target); reprendreImage(event.target); }, true);
      entete.addEventListener('load', function (event) {
        imageSecours(event.target);
        if (attentesImages.has(event.target)) {
          window.clearTimeout(attentesImages.get(event.target));
          attentesImages.delete(event.target);
        }
      }, true);
    }
    // Le tiroir peut etre remplace par la section hydration. toggle ne bulle
    // pas : la capture retrouve aussi les nouveaux details sans les rebrancher.
    document.addEventListener('toggle', function (event) {
      var tiroir = event.target;
      if (tiroir.id === 'Details-menu-drawer-container' && tiroir.open) {
        chargerUneFois(tiroir.querySelector('.menu-drawer') || tiroir);
      }
      if (tiroir.hasAttribute && tiroir.hasAttribute('data-glint-mobile-details') && tiroir.open) chargerUneFois(tiroir);
      annulerReprisesCachees(false);
    }, true);
    document.addEventListener('visibilitychange', function () {
      synchroniserStudios();
      annulerReprisesCachees(false);
      if (!document.hidden) reprendreImages(portee());
    });
    if (studioReduced.addEventListener) studioReduced.addEventListener('change', synchroniserStudios);
    else if (studioReduced.addListener) studioReduced.addListener(synchroniserStudios);
    window.addEventListener('pagehide', function () {
      annulerReprisesCachees(true);
      studiosMotion.forEach(function (controle) { controle.stop(); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
